import { render, staticRenderFns } from "./hairPage.vue?vue&type=template&id=e4167ff2&scoped=true&"
import script from "./hairPage.vue?vue&type=script&lang=js&"
export * from "./hairPage.vue?vue&type=script&lang=js&"
import style0 from "./hairPage.vue?vue&type=style&index=0&id=e4167ff2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4167ff2",
  null
  
)

export default component.exports